export default {
  path: 'lb/product_selection_ack',
  name: 'productSelectionAck_',
  component: () => import('@/pages/lb/selection_ack/Index'),
  meta: { title: '直播选品-确认' }
}
